/*
 *
 * JobsStagesFilterPopup actions
 *
 */

import {
  APPLY_NON_SAVED_FILTER_INIT,
  CLEAR_SELECT_ALL_FUNNELS,
  CREATE_STAGE_FILTER_ERROR,
  CREATE_STAGE_FILTER_INIT,
  CREATE_STAGE_FILTER_SUCCESS,
  DELETE_STAGE_FILTER_ERROR,
  DELETE_STAGE_FILTER_INIT,
  DELETE_STAGE_FILTER_SUCCESS,
  FETCH_STAGE_FILTERS_ERROR,
  FETCH_STAGE_FILTERS_INIT,
  FETCH_STAGE_FILTERS_SUCCESS,
  FUNNELS_SEARCH_COMPLETE,
  LOAD_MORE_FUNNELS,
  LOAD_MORE_FUNNELS_ERROR,
  SELECT_ALL_FUNNELS_ERROR,
  SELECT_ALL_FUNNELS_INIT,
  SELECT_ALL_FUNNELS_SUCCESS,
  SET_SELECTED_FILTER,
  SET_SELECTED_JOBS_DATA,
  UPDATE_FUNNELS_SEARCH,
  UPDATE_STAGE_FILTER_ERROR,
  UPDATE_STAGE_FILTER_INIT,
  UPDATE_STAGE_FILTER_SUCCESS,
} from './constants';

export function fetchStageFiltersAction() {
  return {
    type: FETCH_STAGE_FILTERS_INIT,
  };
}

export function fetchStageFiltersSuccessAction(stageFilters) {
  return {
    type: FETCH_STAGE_FILTERS_SUCCESS,
    stageFilters,
  };
}

export function fetchStageFiltersErrorAction(error) {
  return {
    type: FETCH_STAGE_FILTERS_ERROR,
    error,
  };
}

export function createStageFilterAction(title, stageIdsWithFunnel) {
  return {
    type: CREATE_STAGE_FILTER_INIT,
    title,
    stageIdsWithFunnel,
  };
}

export function createStageFilterSuccessAction(stageFilter) {
  return {
    type: CREATE_STAGE_FILTER_SUCCESS,
    stageFilter,
  };
}

export function createStageFilterErrorAction(error) {
  return {
    type: CREATE_STAGE_FILTER_ERROR,
    error,
  };
}

export function updateStageFilterAction(title, filterId, stageIdsWithFunnel) {
  return {
    type: UPDATE_STAGE_FILTER_INIT,
    title,
    filterId,
    stageIdsWithFunnel,
  };
}

export function updateStageFilterSuccessAction(stageFilter) {
  return {
    type: UPDATE_STAGE_FILTER_SUCCESS,
    stageFilter,
  };
}

export function updateStageFilterErrorAction(error) {
  return {
    type: UPDATE_STAGE_FILTER_ERROR,
    error,
  };
}

export function deleteStageFilterAction(filterId) {
  return {
    type: DELETE_STAGE_FILTER_INIT,
    filterId,
  };
}

export function deleteStageFilterSuccessAction(filterId, data) {
  return {
    type: DELETE_STAGE_FILTER_SUCCESS,
    filterId,
    data,
  };
}

export function deleteStageFilterErrorAction(error) {
  return {
    type: DELETE_STAGE_FILTER_ERROR,
    error,
  };
}

export function setSelectedFilterAction(selectedFilter) {
  return {
    type: SET_SELECTED_FILTER,
    selectedFilter,
  };
}

export function applyNonSavedFilterAction(stageIdsWithFunnel) {
  return {
    type: APPLY_NON_SAVED_FILTER_INIT,
    stageIdsWithFunnel,
  };
}

export function updateSearchTextAction(search, activeOnly) {
  return {
    type: UPDATE_FUNNELS_SEARCH,
    search,
    activeOnly,
  };
}

export function jobsSearchCompleteAction(jobsData, pagination = null, page = 1, epoch = 0) {
  return {
    type: FUNNELS_SEARCH_COMPLETE,
    jobsData,
    pagination,
    page,
    epoch,
  };
}

export function setSelectedJobsDataAction(selectedJobsData) {
  return {
    type: SET_SELECTED_JOBS_DATA,
    selectedJobsData,
  };
}

export function loadMoreFunnelsAction(search, activeOnly, page) {
  return {
    type: LOAD_MORE_FUNNELS,
    search,
    activeOnly,
    page,
  };
}

export function loadMoreFunnelsErrorAction(epoch) {
  return {
    type: LOAD_MORE_FUNNELS_ERROR,
    epoch,
  };
}

export function selectAllFunnelsAction(search, activeOnly) {
  return {
    type: SELECT_ALL_FUNNELS_INIT,
    search,
    activeOnly,
  };
}

export function selectAllFunnelsSuccessAction(
  selectAllSelection,
  search = '',
  activeOnly = false,
  requestId = 0,
) {
  return {
    type: SELECT_ALL_FUNNELS_SUCCESS,
    selectAllSelection,
    search,
    activeOnly,
    requestId,
  };
}

export function selectAllFunnelsErrorAction() {
  return {
    type: SELECT_ALL_FUNNELS_ERROR,
  };
}

export function clearSelectAllFunnelsAction() {
  return {
    type: CLEAR_SELECT_ALL_FUNNELS,
  };
}
